const START_SCALE = 1.13;
const END_SCALE = 1.01;
const START_X_PERCENT = 1.2;
const SWIPE_BLEND_DISTANCE = 0.6;

/** Gentle, symmetric ease for the modal-style outgoing-image fade. */
const getFeatureFadeEase = (progress: number): number => {
  let low = 0;
  let high = 1;
  for (let index = 0; index < 12; index += 1) {
    const middle = (low + high) / 2;
    const inverse = 1 - middle;
    const x =
      3 * inverse * inverse * middle * 0.45 +
      3 * inverse * middle * middle * 0.55 +
      middle ** 3;
    if (x < progress) low = middle;
    else high = middle;
  }
  const time = (low + high) / 2;
  return 3 * (1 - time) * time * time + time ** 3;
};

/** Fade the outgoing image over seconds 4–5 of the nine-second slide. */
export const getFeaturePrimaryImageOpacity = (progress: number): number => {
  if (progress <= 4 / 9) return 1;
  if (progress >= 5 / 9) return 0;
  return 1 - getFeatureFadeEase((progress - 4 / 9) * 9);
};

export const getFeatureImageSwipeBlend = (distance: number): number => {
  const progress = Math.min(
    1,
    Math.max(0, 1 - distance / SWIPE_BLEND_DISTANCE)
  );

  return progress * progress * (3 - 2 * progress);
};

export const getFeatureImageMotionProgress = (
  progress: number,
  startProgress: number,
  startMotion: number
): number => {
  const elapsed = Math.min(1, Math.max(0, progress));
  const start = Math.min(1, Math.max(0, startProgress));
  const motion = Math.min(1, Math.max(0, startMotion));
  if (elapsed <= start) return motion;

  return motion + ((elapsed - start) / (1 - start)) * (1 - motion);
};

export const getFeatureImageMotionTransform = (
  progress: number,
  direction: -1 | 1 = -1
): string => {
  const elapsed = Math.min(1, Math.max(0, progress));
  const translateX = -direction * START_X_PERCENT * (1 - elapsed);
  const scale = START_SCALE + (END_SCALE - START_SCALE) * elapsed;

  return `translate3d(${translateX.toFixed(3)}%, 0, 0) scale(${scale.toFixed(4)})`;
};
